"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomStyles = useCustomStyles;
exports.getCustomStyles = getCustomStyles;

var _getComponentStyle = require("../styleHelpers/getComponentStyle");

var _useComponentStyle = require("../theme/useComponentStyle");

function useCustomStyles(stylesPath) {
  var propStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var customThemeStyles = (0, _useComponentStyle.useComponentStyle)(stylesPath) || {};
  return function (key) {
    return [customThemeStyles[key], propStyles[key]];
  };
}

function getCustomStyles(stylesPath, key) {
  return function (props) {
    var customStyles = props.customStyles || (0, _getComponentStyle.getComponentStyle)(stylesPath)(props) || {};
    return customStyles[key];
  };
}